import type { AlpineComponent } from 'alpinejs'

export const navigation = () => ({
  sidebarExpanded: false,

  NavToggle: {
    '@click': 'sidebarExpanded = !sidebarExpanded',
    ':aria-pressed': 'sidebarExpanded',
    'aria-controls': 'sidebar',
  },

  Sidebar: {
    ':aria-expanded': 'sidebarExpanded',
  },
})

type SubNavComponent = {
  expanded: boolean
  toggleSubNav: (e: PointerEvent) => void
  SubNav: Record<string, string>
  SubNavLink: Record<string, string>
}

export const subNavWrapper = (): AlpineComponent<SubNavComponent> => ({
  expanded: false,

  init() {
    this.expanded = !!this.$root.querySelector('[aria-current=true]')
  },

  // Open the sub nav instead of using as a link when the sub nav arrows are visible (on mobile)
  toggleSubNav(e: PointerEvent) {
    if (getComputedStyle(this.$el, '::after').display !== 'none') {
      e.preventDefault()
      this.expanded = !this.expanded
    }
  },

  SubNav: {
    ':aria-expanded': 'expanded',
    'x-show': 'expanded',
    'x-cloak': '',
    'x-collapse': '',
  },

  SubNavLink: {
    '@click': 'toggleSubNav($event)',
  },
})
